import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { STORAGE_KEYS } from '../utils/consts';
import { NotificationIntroDialogComponent } from '../ui/notifications/notification-intro-dialog/notification-intro-dialog.component';

/**
 * One-time explainer for the reporting reminder notifications feature.
 * TODO(cleanup): remove this dialog, service, and the
 * `equip-track-notification-intro-seen` localStorage flag once the feature
 * has been live long enough that users no longer need the explainer.
 * Tracked in Linear.
 */
@Injectable({ providedIn: 'root' })
export class NotificationIntroService {
  private readonly dialog = inject(MatDialog);
  private shownThisSession = false;

  showIfNeeded(): void {
    if (this.shownThisSession || this.hasSeenIntro() || this.isE2eSession()) {
      return;
    }
    this.shownThisSession = true;
    const ref = this.dialog.open(NotificationIntroDialogComponent, {
      width: '420px',
      disableClose: false,
    });
    ref.afterClosed().subscribe((dismissed) => {
      if (dismissed) {
        this.markIntroSeen();
      }
    });
  }

  private hasSeenIntro(): boolean {
    try {
      return localStorage.getItem(STORAGE_KEYS.NOTIFICATION_INTRO_SEEN) === 'true';
    } catch {
      return false;
    }
  }

  private markIntroSeen(): void {
    try {
      localStorage.setItem(STORAGE_KEYS.NOTIFICATION_INTRO_SEEN, 'true');
    } catch (error) {
      console.error('Failed to persist notification intro flag:', error);
    }
  }

  private isE2eSession(): boolean {
    try {
      if (typeof globalThis === 'undefined') {
        return false;
      }
      const win = globalThis as unknown as { __EQUIP_TRACK_E2E__?: boolean };
      return win.__EQUIP_TRACK_E2E__ === true;
    } catch {
      return false;
    }
  }
}
